/* eslint-disable @typescript-eslint/no-explicit-any */
import { ContentContainer, PageLayout, PageTitle } from "components/layout";
import React from "react";
import { DataTable } from "../components/data-table";
import { columns } from "../components/columns";
import { useGetNcmQuery } from "@/services/ncm";

import { handeOrderBy } from "@/utils/pagination";
import { useFilterState } from "@/pages/users/ducks/filter/hooks/filterState";
import { Load } from "components/load";
import PageError from "components/page-error";

export const ConfigTax: React.FC = () => {
  const filterState = useFilterState();
  const { filters } = filterState || { filters: {} };
  const orderBy = handeOrderBy(filters.order);

  const {
    data: accessRequest,
    isLoading,
    isFetching,
    error,
  } = useGetNcmQuery({
    state: filters.state || "",
    search: filters.search || "",
    orderBy: JSON.stringify(orderBy),
    ncm: filters.ncm || "",
    is_active: filters.is_active || "",
    meta: {
      page: (filterState as any)?.filters.meta?.page || 1,
      perPage: (filterState as any)?.filters.meta?.perPage || 10,
    },
  });

  const { data, meta } = accessRequest || { data: [], meta: {} };

  if (isLoading) return <Load />;
  if (error) {
    return <PageError status={500} message={"ERRO INTERNO NO SERVIDOR"} />;
  }

  return (
    <PageLayout>
      <PageTitle
        title="NCM"
        description="Acompanhe as configurações de NCM do sistema"
      />
      <ContentContainer>
        <DataTable
          data={data as any}
          columns={columns}
          meta={meta as any}
          isLoading={isFetching}
        />
      </ContentContainer>
    </PageLayout>
  );
};
